export const staticConstants = {
    ALL_NOTIFICATIONS: "ALL_NOTIFICATIONS",
    NEW_NOTIFICATIONS: "NEW_NOTIFICATIONS",
    NOTIFICATION_COUNT: "NOTIFICATION_COUNT",
    NOTIFICATION: "NOTIFICATION",
    GET_THANA_REQUEST: "GET_THANA_REQUEST",
    GET_THANA_SUCCESS: "GET_THANA_SUCCESS",
    GET_THANA_FAIL: "GET_THANA_FAIL",
       
}